import { useParams } from 'peach/router'

export const useCompanyId = () => {
  const { companyId } = useParams()
  return companyId
}

export { default as CompanyManager } from './CompanyManager'
export { default as CompanyAgentUserSelect } from './components/CompanyAgentUserSelect'
export { default as CompanyEmployeeSelect } from './components/CompanyEmployeeSelect'
export { default as CompanyPermissionSelect } from './components/CompanyPermissionSelect'
export { default as CompanyRolesSelect } from './components/CompanyRolesSelect'
export { default as CompanyTeamSelect } from './components/CompanyTeamSelect'
export { default as LoanTypeSelect } from './components/LoanTypeSelect'
